import { LoadingOverlay } from "@medoma/components/Loading/Loading";
import styles from "./AllocateToShiftTile.module.scss";
import enlargedDropZone from "../DragAndDrop/enlargedDropZone.module.scss";
import { DropZone } from "@/components/DragAndDrop/DropZone";
import { type IScheduledShift } from "@medoma/models/shifts";
import clsx from "clsx";
import { useDragAndDropContext } from "../DragAndDrop/DragAndDropContext";
import { getShiftDropZoneLabel } from "../DragAndDrop/dragAndDropUtils";
import { useIsShiftDropZoneAvailable } from "../DragAndDrop/useIsShiftDropZoneAvailable";
import { useDropToShift } from "../DragAndDrop/useDropToShift";

export const AllocateToShiftTile = ({
  shift,
  isDropZoneEnlarged,
  children,
}: {
  shift: IScheduledShift;
  isDropZoneEnlarged: boolean;
  children: React.ReactNode;
}) => {
  const { drag } = useDragAndDropContext();
  const { id: shiftId } = shift;

  const isShiftDropZoneAvailable = useIsShiftDropZoneAvailable({ shiftId });

  const { handleDrop, isPending } = useDropToShift(shiftId);

  return (
    <LoadingOverlay show={isPending} className={styles.subgridPassthrough}>
      <DropZone
        ariaLabel={getShiftDropZoneLabel(drag, shift)}
        onDrop={handleDrop}
        className={clsx(
          styles.dropZone,
          isShiftDropZoneAvailable &&
            drag &&
            (isDropZoneEnlarged ? enlargedDropZone.dropZone : styles.selected),
        )}
        isDisabled={!isShiftDropZoneAvailable}
      >
        {children}
      </DropZone>
    </LoadingOverlay>
  );
};
